import React from 'react';
import { useSelector } from 'react-redux';

import { InputText } from "../PrimeReactComponents";
import { Oval } from 'react-loader-spinner';
import { checkPermissions } from '../utils';

import PermDetailsWrapper from '../common/PermDetailsWrapper';

function TextInputField(props) {
    const userDetails = useSelector(state => state.userDetails)

    const optionalProps = {} 

    const labelText = props.labelText ? props.labelText : ""
    const placeholder = props.placeholder ? props.placeholder : ""
    let value = props.value || props.value === 0 ? props.value : ''
    let keyfilter = props.keyfilter ? props.keyfilter : ''
    let autoComplete = props.autoComplete ? props.autoComplete : ''
    let tooltip = props.tooltip ? props.tooltip : ''
    let tooltipOptions = props.tooltipOptions ? props.tooltipOptions : {}
    let className = props.className ? props.className : ""
    const maxLength = props.maxLength ? props.maxLength : 10000000
    const isLoading = props.loading ? props.loading : false 
    let refName = props.refName ? props.refName : null

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}
    
    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }

        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }
    
    if(props.errorBorder){
        className = className + " red-border"
    }

    const labelStyle = props.labelStyle ? props.labelStyle : {}
    const inputStyle = props.inputStyle ? props.inputStyle : {}

    const handleOnchange = (e) => {
        if (props.onChange) {
            props.onChange(e)
        }
    }

    const handleOnKeyDown = (e) => {
        if (props.onKeyDown) {
            props.onKeyDown(e)
        }
    }

    const handleOnBlur = (e) => {
        if (props.onBlur) {
            props.onBlur(e)
        }
    }

    const handleDragOver = (event) => {
        if (props.onDragOver) {
            props.onDragOver(event)
        } 
    }

    const handleDrop = (event) => {
        if (props.onDrop) {
            props.onDrop(event)
        } 
    }

    const handleOnCopy = (event) => {
        if (props.preventCopy) {
            event.preventDefault()
        }
    }

    const handleOnCut = (event) => {
        if (props.preventCut) {
            event.preventDefault()
        }
    }

    const handleOnPaste = (event) => {
        if (props.preventPaste) {
            event.preventDefault()
        }
    }

    const renderInputField = () => (
        <>
            {
                labelText ? 
                    <label htmlFor="" style={{ fontSize: '12px', marginBottom: '3px', ...labelStyle }}>{labelText}{props.required && <span style={{color:"red"}}>*</span>}</label> 
                    : ""
            }
            <InputText 
                className={className}
                tooltip={tooltip} 
                name={props.name} 
                keyfilter={keyfilter} 
                autoComplete= "off" //{autoComplete} 
                placeholder={placeholder} 
                value={value} 
                type={props.type}
                tooltipOptions={tooltipOptions} 
                style={{...inputStyle}} 
                onChange={(e) => handleOnchange(e)} 
                onBlur={(e) => handleOnBlur(e)} 
                onKeyDown={(e) => handleOnKeyDown(e)}
                disabled={disabled} 
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                maxLength={maxLength}
                ref={refName}
                onCopy={handleOnCopy} 
                onCut={handleOnCut} 
                onPaste={handleOnPaste} 
            />
            {isLoading && <Oval
                height="20"
                width="20"
                radius="6"
                color="#000"
                secondaryColor="#000"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ position: 'absolute', marginTop: '1.3rem' }}
                wrapperClassName=""
                visible={true}
            />}
            { props.errorMessage && <small className='p-error' style={{ fontSize: 'x-small', marginTop: '0.25rem' }}>{props.errorMessage}</small> }
        </>
    );
    
    return (
        <PermDetailsWrapper
            displayComponent={renderInputField()}
            uniqueId={props.labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default TextInputField;